import React from 'react';
import { Box, TextField, Grid } from '@mui/material';
import { SecondarySectionTitle, SectionTitle } from './ContactForm.styles';
import { useFormikContext } from 'formik';
import { ContactInfo, ContactInfoUpdate } from '../../api/generated';


export default function ContactFormFields() {
    const {
        values,
        touched,
        errors,
        handleChange,
        handleBlur,
    } = useFormikContext<ContactInfoUpdate>();

    const getFieldProps = (fieldPath: string) => {
        const fieldNames = fieldPath.split('.');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let error:any = errors;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let isTouched:any = touched;
        for (const name of fieldNames) {
            if (error && error[name] !== undefined) error = error[name];
            else error = undefined;
            if (isTouched && isTouched[name] !== undefined) isTouched = isTouched[name];
            else isTouched = undefined;
        }
        return {
            error: Boolean(isTouched && error),
            helperText: isTouched && error ? error : undefined
        };
    };

    return (
        <Box>
            {/* Primary Business Contact Section */}
            <Box>
                <SectionTitle sx={{ marginBottom: 2 }}>
                    Primary Business Contact
                </SectionTitle>
                <Grid container spacing={2}>
                    <Grid item md={3.5}>
                        <TextField
                            fullWidth
                            label="Full Name"
                            variant="outlined"
                            name="primary_contact.full_name"
                            size="small"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.primary_contact.full_name}
                            {...getFieldProps('primary_contact.full_name')}
                        />
                    </Grid>
                    <Grid item md={2.5}>
                        <TextField
                            fullWidth
                            label="Job Title/Role"
                            variant="outlined"
                            name="primary_contact.job_title"
                            size="small"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.primary_contact.job_title}
                            {...getFieldProps('primary_contact.job_title')}
                        />
                    </Grid>
                    <Grid item md={2.5}>
                        <TextField
                            fullWidth
                            label="Business Email Address"
                            variant="outlined"
                            name="primary_contact.email_address"
                            size="small"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.primary_contact.email_address}
                            {...getFieldProps('primary_contact.email_address')}
                        />
                    </Grid>
                    <Grid item md={2}>
                        <TextField
                            fullWidth
                            label="Direct Phone Number"
                            variant="outlined"
                            name="primary_contact.phone_number"
                            size="small"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.primary_contact.phone_number}
                            {...getFieldProps('primary_contact.phone_number')}
                        />
                    </Grid>
                    <Grid item md={2.5}>
                        <TextField
                            fullWidth
                            label="Department (optional)"
                            variant="outlined"
                            name="primary_contact.department"
                            size="small"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.primary_contact.department || ""}
                            {...getFieldProps('primary_contact.department')}
                        />
                    </Grid>
                </Grid>
            </Box>

            {/* Technical Contact */}
            <Box sx={{ marginTop: 4 }}>
                <SectionTitle sx={{ marginBottom: 2 }}>
                    Technical Contact
                </SectionTitle>
                <Grid container spacing={2}>
                    <Grid item md={3.5}>
                        <TextField
                            fullWidth
                            label="Full Name"
                            variant="outlined"
                            name="technical_contact.full_name"
                            size="small"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.technical_contact.full_name}
                            {...getFieldProps('technical_contact.full_name')}
                        />
                    </Grid>
                    <Grid item md={2.5}>
                        <TextField
                            fullWidth
                            label="Job Title/Role"
                            variant="outlined"
                            name="technical_contact.job_title"
                            size="small"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.technical_contact.job_title}
                            {...getFieldProps('technical_contact.job_title')}
                        />
                    </Grid>
                    <Grid item md={2.5}>
                        <TextField
                            fullWidth
                            label="Email Address"
                            variant="outlined"
                            name="technical_contact.email_address"
                            size="small"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.technical_contact.email_address}
                            {...getFieldProps('technical_contact.email_address')}
                        />
                    </Grid>
                    <Grid item md={2}>
                        <TextField
                            fullWidth
                            label="Phone Number"
                            variant="outlined"
                            name="technical_contact.phone_number"
                            size="small"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.technical_contact.phone_number}
                            {...getFieldProps('technical_contact.phone_number')}
                        />
                    </Grid>
                </Grid>
            </Box>

            {/* Billing/Finance Contact */}
            <Box sx={{ marginTop: 4 }}>
                <SectionTitle sx={{ marginBottom: 2 }}>
                    Billing/Finance Contact
                </SectionTitle>
                <Grid container spacing={2}>
                    <Grid item md={3}>
                        <TextField
                            fullWidth
                            label="Legal Entity Name"
                            variant="outlined"
                            name="billing_contact.legal_entity"
                            size="small"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.billing_contact.legal_entity}
                            {...getFieldProps('billing_contact.legal_entity')}
                        />
                    </Grid>
                    <Grid item md={2.5}>
                        <TextField
                            fullWidth
                            label="Full Name"
                            variant="outlined"
                            name="billing_contact.full_name"
                            size="small"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.billing_contact.full_name}
                            {...getFieldProps('billing_contact.full_name')}
                        />
                    </Grid>
                    <Grid item md={2.5}>
                        <TextField
                            fullWidth
                            label="Job Title/Role"
                            variant="outlined"
                            name="billing_contact.job_title"
                            size="small"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.billing_contact.job_title}
                            {...getFieldProps('billing_contact.job_title')}
                        />
                    </Grid>
                    <Grid item md={2}>
                        <TextField
                            fullWidth
                            label="Email Address"
                            variant="outlined"
                            name="billing_contact.email_address"
                            size="small"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.billing_contact.email_address}
                            {...getFieldProps('billing_contact.email_address')}
                        />
                    </Grid>
                    <Grid item md={2}>
                        <TextField
                            fullWidth
                            label="Direct phone number"
                            variant="outlined"
                            name="billing_contact.phone_number"
                            size="small"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.billing_contact.phone_number}
                            {...getFieldProps('billing_contact.phone_number')}
                        />
                    </Grid>
                </Grid>
            </Box>

            {/* Billing Address Section */}
            <Box sx={{ marginTop: 4 }}>
                <SectionTitle sx={{ marginBottom: 2 }}>
                    Billing Address
                </SectionTitle>
                <Grid container spacing={2}>
                    <Grid item md={3.5}>
                        <TextField
                            fullWidth
                            label="Street"
                            variant="outlined"
                            name="billing_contact.street"
                            size="small"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.billing_contact.street}
                            {...getFieldProps('billing_contact.street')}
                        />
                    </Grid>
                    <Grid item md={2.5}>
                        <TextField
                            fullWidth
                            label="City"
                            variant="outlined"
                            name="billing_contact.city"
                            size="small"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.billing_contact.city}
                            {...getFieldProps('billing_contact.city')}
                        />
                    </Grid>
                    <Grid item md={2.5}>
                        <TextField
                            fullWidth
                            label="State/County"
                            variant="outlined"
                            name="billing_contact.state"
                            size="small"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.billing_contact.state}
                            {...getFieldProps('billing_contact.state')}
                        />
                    </Grid>
                                        <Grid item md={1.5}>
                        <TextField
                            fullWidth
                            label="Zip/Post Code"
                            variant="outlined"
                            name="billing_contact.zip"
                            size="small"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.billing_contact.zip}
                            {...getFieldProps('billing_contact.zip')}
                        />
                    </Grid>
                    <Grid item md={2}>
                        <TextField
                            fullWidth
                            label="Country"
                            variant="outlined"
                            name="billing_contact.country"
                            size="small"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.billing_contact.country}
                            {...getFieldProps('billing_contact.country')}
                        />
                    </Grid>
                </Grid>
            </Box>

            {/* Support/Emergency Contact Section */}
            <Box sx={{ marginTop: 4 }}>
                <SectionTitle sx={{ marginBottom: 2 }}>
                    Support/Emergency Contact
                </SectionTitle>
                <Grid container spacing={2}>
                    <Grid item md={3.5}>
                        <TextField
                            fullWidth
                            label="Full Name"
                            variant="outlined"
                            name="support_contact.full_name"
                            size="small"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.support_contact.full_name}
                            {...getFieldProps('support_contact.full_name')}
                        />
                    </Grid>
                    <Grid item md={2.5}>
                        <TextField
                            fullWidth
                            label="Email Address"
                            variant="outlined"
                            name="support_contact.email_address"
                            size="small"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.support_contact.email_address}
                            {...getFieldProps('support_contact.email_address')}
                        />
                    </Grid>
                    <Grid item md={2.5}>
                        <TextField
                            fullWidth
                            label="24/7 Phone Number (if available)"
                            variant="outlined"
                            name="support_contact.phone_number"
                            size="small"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.support_contact.phone_number || ""}
                            {...getFieldProps('support_contact.phone_number')}
                        />
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
}
